









































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import PendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'

@Component

export default class ComponentConfirmarPendenciaBase extends Vue {
  loadConfirmar: boolean = false

  get loadingConfirmar() {
    return this.loadConfirmar
  }

  set loadingConfirmar(value: boolean) {
    this.loadConfirmar = value
  }

  get getPendenciaStore() {
    return getModule(PendenciaStore, this.$store)
  }

  get getPendenciaMensagem() {
    return this.getPendenciaStore.pendencia.mensagens
  }

  clearMensagem() {
    this.getPendenciaStore.clearMensagem()
  }
}
